import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';
const RED = '#c41e3a';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [form, setForm] = useState({ new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.new_password || !form.confirm_password) { toast.error('Please fill all fields'); return; }
    if (form.new_password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (form.new_password !== form.confirm_password) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, new_password: form.new_password });
      toast.success('Password reset successfully!');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid or expired link');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${NAVY} 0%, #1e3a5f 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ background: '#fff', borderRadius: 12, padding: 40, textAlign: 'center' }}>
          <p style={{ color: RED, fontWeight: 600 }}>Invalid reset link.</p>
          <Link to="/login" style={{ color: NAVY, fontSize: 13 }}>← Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, ${NAVY} 0%, #1e3a5f 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '40px 36px', width: '100%', maxWidth: 380, boxShadow: '0 24px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: NAVY }}>DHA MEDICAL CENTRE</div>
          <div style={{ display: 'flex', justifyContent: 'center', height: 3, margin: '8px auto', width: 120 }}>
            <div style={{ flex: 1, background: RED }} />
            <div style={{ flex: 1, background: '#fff', border: '1px solid #ddd' }} />
            <div style={{ flex: 1, background: GREEN }} />
          </div>
        </div>

        <h3 style={{ color: NAVY, marginBottom: 6, fontSize: 18, fontWeight: 800 }}>Reset Password</h3>
        <p style={{ color: '#64748b', fontSize: 12, marginBottom: 20 }}>Enter your new password below.</p>

        <form onSubmit={handleSubmit}>
          {[
            { label: 'New Password', key: 'new_password' },
            { label: 'Confirm Password', key: 'confirm_password' },
          ].map(({ label, key }) => (
            <div key={key} style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>{label}</label>
              <input
                type="password"
                value={form[key]}
                onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                style={{ width: '100%', padding: '10px 12px', borderRadius: 7, border: '1.5px solid #d1d5db', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
          ))}
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', padding: '11px', borderRadius: 7, background: loading ? '#94a3b8' : NAVY, color: '#fff', fontWeight: 700, fontSize: 15, border: 'none', cursor: loading ? 'not-allowed' : 'pointer', marginTop: 8 }}
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
